export const downloadFromURL = (fileName, url) => fetch(url)
  .then((response) => {
    if (!response.ok) throw new Error('Network response was not ok');

    response.blob().then((blob) => downloadFromBlob(fileName, blob));
  });

export const downloadFromBlob = (fileName, blob) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(link.href);
};

const CSV_FILENAME_MAX_LENGTH = 200;

export function csvFilename(rawTitle, contentDisposition, defaultTitle = 'Export') {
  const timestamp = new Date().toISOString().replace(/\.\d{3}Z$/, 'Z');
  const title = rawTitle?.trim();
  if (title) {
    const sanitized = title
      .replace(/[/\\:*?"<>|]/g, '_')
      .replace(/_+/g, '_')
      .trim()
      .slice(0, CSV_FILENAME_MAX_LENGTH);
    if (sanitized) {
      return `${sanitized}_${timestamp}.csv`;
    }
  }
  if (contentDisposition?.includes('filename=')) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match?.[1]) {
      return match[1];
    }
  }
  return `${defaultTitle}_${timestamp}.csv`;
}
